export const customVerticalScrollBar = {

	data: function () {
		return {
			scrollBar: {
				height: 0,
				top: 0,
				bottom: 0,
				width: 0
			},
			moving: {
				isTouch: false
			}
		}
	},
	methods: {

		initVerticalScrollBar() {

			const scrollAreaWrap = this.$refs.scrollAreaWrap;
			const scrollBarWrap = this.$refs.scrollBarWrap;
			let scrollHeightCoef;

			this.scrollBar.height = scrollBarWrap.clientHeight * scrollAreaWrap.clientHeight / scrollAreaWrap.scrollHeight;

			this.scrollBar.height > 30 ?
				scrollHeightCoef = 0 :
				scrollHeightCoef = 30;

			if (!this.moving.isTouch)
				this.scrollBar.top =
					(scrollBarWrap.clientHeight - scrollHeightCoef) * scrollAreaWrap.scrollTop / scrollAreaWrap.scrollHeight;

		},
		behaviorVerticalScroll(start) {
			const scrollAreaWrap = this.$refs.scrollAreaWrap;
			const scroll = this.$refs.verticalScroll;
			const scrollBarWrap = this.$refs.scrollBarWrap;
			const offsetTop = scroll.offsetTop;

			const move = end => {
				this.moving.isTouch = true;
				const delta = end.pageY - start.pageY;

				let scrollHeight;
				if (scrollAreaWrap)
					scrollHeight = (scrollBarWrap.clientHeight * scrollAreaWrap.clientHeight / scrollAreaWrap.scrollHeight);

				let scrollHeightCoef;
				scrollHeight > 30 ?
					scrollHeightCoef = scrollHeight :
					scrollHeightCoef = 30;

				this.scrollBar.top =
					Math.min(scrollBarWrap.clientHeight - scrollHeightCoef, Math.max(0, offsetTop + delta));

				scrollAreaWrap.scrollTop =
					(scrollAreaWrap.scrollHeight * scroll.offsetTop / (scrollBarWrap.clientHeight - scrollHeightCoef));

			};

			document.addEventListener('mousemove', move);
			document.addEventListener('mouseup', () => {
				document.removeEventListener('mousemove', move);
				this.moving.isTouch = false;
			});
		}
	}
};

export const horizontalCustomScrollBar = {

	data: function () {
		return {
			scrollBar: {
				width: 0,
				left: 0
			},
			moving: {
				isTouch: false
			}
		}
	},
	methods: {
		initHorizontalScrollBar() {

			const scrollAreaWrap = this.$refs.scrollAreaWrap;
			const scrollBarWrap = this.$refs.horizontalScrollBarWrap;
			let scrollHeightCoef;

			this.scrollBar.width = scrollBarWrap.clientWidth * scrollAreaWrap.clientWidth / scrollAreaWrap.scrollWidth;

			this.scrollBar.width > 30 ?
				scrollHeightCoef = 0 :
				scrollHeightCoef = 30;

			if (!this.moving.isTouch)
				this.scrollBar.left =
					(scrollBarWrap.clientWidth - scrollHeightCoef) * scrollAreaWrap.scrollLeft / scrollAreaWrap.scrollWidth;

		},
		behaviorHorizontalScroll(start) {
			const scrollAreaWrap = this.$refs.scrollAreaWrap;
			const scroll = this.$refs.horizontalScroll;
			const scrollBarWrap = this.$refs.horizontalScrollBarWrap;
			const offsetLeft = scroll.offsetLeft;

			const move = end => {
				this.moving.isTouch = true;
				const delta = end.pageX - start.pageX;

				let scrollWidth;
				if (scrollAreaWrap)
					scrollWidth = (scrollBarWrap.clientWidth * scrollAreaWrap.clientWidth / scrollAreaWrap.scrollWidth);

				let scrollHeightCoef;
				scrollWidth > 30 ?
					scrollHeightCoef = 0 :
					scrollHeightCoef = 30;

				this.scrollBar.left =
					Math.min(scrollBarWrap.clientWidth - scrollHeightCoef, Math.max(0, offsetLeft + delta));

				scrollAreaWrap.scrollLeft =
					(scrollAreaWrap.scrollWidth * scroll.offsetLeft / (scrollBarWrap.clientWidth - scrollHeightCoef));

				if (this.scrollBar.width + this.scrollBar.left >= scrollBarWrap.clientWidth) {
					this.scrollBar.left = scrollBarWrap.clientWidth - this.scrollBar.width;
				}

			};

			document.addEventListener('mousemove', move);
			document.addEventListener('mouseup', () => {
				document.removeEventListener('mousemove', move);
				this.moving.isTouch = false;
			});
		}
	}


};